import { jsx as a } from "react/jsx-runtime";
import { cn as n } from "./designsystem-ui-react47.js";
function p({ padding: t = "responsive", className: s, children: e }) {
  return /* @__PURE__ */ a("div", { className: n("tw-flex tw-flex-col tw-gap-2 tw-flex-1", {
    small: "tw-p-3",
    medium: "tw-p-4",
    large: "tw-p-5",
    responsive: "tw-p-4 @sm:tw-p-5"
  }[t], s), children: e });
}
p.displayName = "CardContent";
export {
  p as CardContent
};
